import usePageMetadata from '@hooks/usePageMetadata'

const useIsInTeamPage = (): boolean => {
  const pageMetadata = usePageMetadata()
  return pageMetadata.targetContentSubType === 'competitor'
}

export default useIsInTeamPage
